module.exports = __webpack_public_path__ + "img/profile.9bb4ad59.svg";